import { useDispatch } from "react-redux";

import { useQuery } from "@tanstack/react-query";

import { apiThatThrows } from "containers/Request";
import { ApiQueryParams, ApiResponse } from "types/api";

import { TiVoDevicePlatform } from "./types";

export const usePlatforms = (queryParams?: ApiQueryParams) => {
  const dispatch = useDispatch();

  return useQuery<ApiResponse<TiVoDevicePlatform[]>>({
    queryKey: ["platforms", queryParams],
    queryFn: () =>
      dispatch(
        apiThatThrows.getTiVoPlatforms.action({
          queryParams,
        })
      ),
  });
};
